import { memo, Suspense, useRef } from 'react';

import { APP_SETTINGS } from '../../../app-settings';
import { useContainerQueryUp } from '../../../hooks/use-container-query';
import { ErrorBoundary } from '../../error-boundary/error-boundary';
// eslint-disable-next-line import/named
import { Footer } from '../footer';

import './footer-wrapper.scss';

const FooterFallback = () => (
  <footer className="sb-Footer sb-FooterFallback">
    <p>An error occurred while loading the footer. Please refresh the page or try again later.;</p>
  </footer>
);

function FooterWrapperUI() {
  const wrapperRef = useRef(null);
  const isDesktop = useContainerQueryUp(wrapperRef, APP_SETTINGS.FOOTER_DESKTOP_BREAKPOINT || 768);

  // Suspense is used to catch server-side errors https://github.com/reactjs/rfcs/pull/215
  return (
    <div ref={wrapperRef} className="sb-FooterWrapper">
      <ErrorBoundary fallback={FooterFallback}>
        <Suspense fallback={FooterFallback}>
          <Footer isDesktop={isDesktop} />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export const FooterWrapper = memo(FooterWrapperUI);
